import { Button } from 'antd';
import styled from 'styled-components';
export const AddButton = styled(Button)`
  color: #98a9bc;
  border-color: #98a9bc;
  padding: 0px 15px;
  margin-right: 10px;
`;